import { OrganizationAction } from "@common/userOrganizationRoles";
import { useActiveOrganization } from "@hooks/useActiveOrganization";
import { useCanPerformOrganizationAction } from "./useCanPerformOrganizationAction";

/**
 * Returns whether the current user can manage the organization's Platform API
 * credentials. Requires both:
 *   - the organization to be enrolled into the Platform (`platformEnabledAt`), and
 *   - the user to hold the MANAGE_ORGANIZATION_SETTINGS action (admins/owners).
 */
export function useCanManageOrganizationApi(): boolean {
    const organization = useActiveOrganization();
    const canManageSettings = useCanPerformOrganizationAction(
        OrganizationAction.MANAGE_ORGANIZATION_SETTINGS,
    );

    return Boolean(organization?.platformEnabledAt) && canManageSettings;
}
